import { AgentConfigRoute } from "@/components/agents/agents-workbench";
import { agentConfigRouteOptions } from "@/components/agents/config-route-options";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$owner/agents/$agentId/identity")({
	...agentConfigRouteOptions,
	component: AgentIdentityPage,
});

function AgentIdentityPage() {
	const { owner, agentId } = Route.useParams();
	const search = Route.useSearch();
	return (
		<AgentConfigRoute
			owner={owner}
			agentId={agentId}
			tab="identity"
			runId={search.run_id}
		/>
	);
}
